import { Select, SelectProps } from 'antd'
import React, { useMemo } from 'react'
import { LoaderMetadata } from '../../models/LLM';

type Props = {
  value?: string;
  loaders?: LoaderMetadata[];
  onChange?: SelectProps['onSelect'];
}

export default function LoaderClassDropdown({ value, loaders, onChange }: Props) {

  const options = useMemo(() => {
    return loaders?.map(opt => ({
      label: (
        <>
          <h6 className="mb-0">{opt.name}</h6>
          <span className="line-clamp-2 text-muted">{opt.description}</span>
        </>
      ),
      value: opt.name,
    })) || [];
  }, [loaders]);

  return (
    <Select
      loading={!options}
      virtual={true}
      options={options}
      className="w-100 h-auto"
      showSearch
      value={value}
      onChange={onChange}
      placeholder="Select loader class..."
      allowClear
    />
  )
}